import moment from 'moment'
import {
  prop, pipe, path, find, propEq,
  ifElse
} from 'ramda'
import numeral from 'numeral'

export const generalData = {
  typePaymentProvider: {
    value: '',
    name: 'typePaymentProvider',
    label: 'Tipo de pago',
    valueProperty: 'id',
    valueLabel: 'tipoPago',
  },
  idProveedor: {
    value: '',
    validation: 'required',
    name: 'idProveedor',
    label: 'Proveedor',
    valueProperty: 'id',
    valueLabel: 'nombreORazonSocial',
    disabled: true,
    // trigger: 'getProvider',
  },
  invoice: {
    value: '',
    vame: 'invoice',
    label: 'Cargar Factura',
  },
  estatusOrden: {
    value: '',
    name: 'estatusOrden',
    label: 'Estatus',
    valueProperty: 'id',
    valueLabel: 'estatus',
    disabled: true,
  },
}
export const conceptsCol = [
  {
    title: 'Colaborador',
    datakey: 'colaborador',
  },
  {
    title: 'Clabe',
    datakey: 'cuentaColaborador',
  },
  {
    title: 'Neto a pagar',
    datakey: 'netoPagar',
    format: '$ 0,0.00',
  },
  {
    title: 'Subtotal',
    datakey: 'subtotal',
    format: '$ 0,0.00',
  },
  {
    title: 'IVA',
    datakey: 'iva',
    format: '$ 0,0.00',
  },
  {
    title: 'Total',
    datakey: 'total',
    format: '$ 0,0.00',
  },
  {
    title: 'Acciones',
    custom: 'acciones',
  }
]
export const addressData = {
  direccion: {
    value: '',
    transform: 'stringToBool',
    trigger: 'onChangeDireccion',
    name: 'direccion',
    label: 'Dirección',
    disabled: true,
  },
  pais: {
    name: 'pais',
    value: '',
    validation: 'requiredIf:direccion',
    label: 'País',
    disabled: true
  },
  codigoPostal: {
    value: '',
    trigger: 'onChangeCp',
    pattern: 'number',
    name: 'codigoPostal',
    label: 'Código postal',
    disabled: true,
  },
  entidadFederativa: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'entidadFederativa',
    label: 'Entidad Federativa/Estado/Provincia',
    disabled: true,
  },
  municipio: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'municipio',
    label: 'Municipio',
    disabled: true,
  },
  colonia: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'colonia',
    label: 'Colonia',
    disabled: true,
  },
  calle: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'calle',
    label: 'Calle',
    disabled: true,
  },
  exterior: {
    value: '',
    validation: 'requiredIf:direccion',
    name: 'exterior',
    label: 'Exterior',
    disabled: true,
  },
  interior: {
    value: '',
    name: 'interior',
    label: 'Interior',
    disabled: true,
  },
}
export const paymentData = {
  metodoPago: {
    value: '1',
    name: 'metodoPago',
    label: 'Método de pago',
    valueProperty: 'id',
    valueLabel: 'metodo',
    trigger: 'onChangePaymentMethod',
    transform: 'stringToNumber',
    validation: 'required',
    disabled: true,
  },
  divisaMoneda: {
    value: 'MXN',
    name: 'divisaMoneda',
    label: 'Moneda Abono Proveedor',
    options: [
      { id: 'MXN', label: 'MXN' },
    ],
    valueProperty: 'id',
    valueLabel: 'label',
    validation: 'required',
    disabled: true,
  },
  referencia: {
    value: moment().format('DDMMYY'),
    name: 'referencia',
    label: 'Referencia',
    maxLength: '7',
    pattern: 'number',
  },
  retirementAccount: {
    value: '',
    name: 'retirementAccount',
    label: 'Cuenta de retiro',
  },
  exchange: {
    name: 'exchange',
    label: 'Tipo de cambio',
    value: '1',
  },
  cuentaClabeBeneficiario: {
    value: '',
    name: 'cuentaClabeBeneficiario',
    label: 'Cuenta Clabe Beneficiario',
    valueProperty: 'id',
    validation: 'required',
  },
  cuentaRetiro: {
    value: '',
    name: 'cuentaRetiro',
    label: 'Cuenta Retiro',
    same: 'divisaMoneda'
  }
}

export const conceptCommand = {
  descripcion: prop('@Descripcion'),
  unidad: prop('@Unidad'),
  valorUnitario: prop('@ValorUnitario'),
  isrRetenido: obj => {
    const retenido = path(['cfdi:Impuestos', 'cfdi:Retenciones', 'cfdi:Retencion'])(obj)
    let totalRetenido
    if (Array.isArray(retenido)) {
      totalRetenido = retenido.reduce((acc, cur) => {
        return acc += Number.parseFloat(prop('@Importe')(cur))
      }, 0)

    } else {
      totalRetenido = Number.parseFloat(prop('@Importe')(retenido))
    }
    return totalRetenido
  },
  ivaRetenido: obj => {
    const translados = path(['cfdi:Impuestos', 'cfdi:Traslados', 'cfdi:Traslado'])(obj)
    let totalTransladado;
    if (Array.isArray(translados)) {
      totalTransladado = translados.reduce((acc, cur) => {
        return acc += Number.parseFloat(prop('@Importe')(cur))
      }, 0)
      totalTransladado = Math.round(totalTransladado * 100) / 100
    } else {
      totalTransladado = Math.round(Number.parseFloat(prop('@Importe')(translados)) * 100) / 100
    }
    return totalTransladado
  },
  netoDepositar: obj => {
    const retenido = path(['cfdi:Impuestos', 'cfdi:Retenciones', 'cfdi:Retencion'])(obj)
    const translados = path(['cfdi:Impuestos', 'cfdi:Traslados', 'cfdi:Traslado'])(obj)
    const subtotal = Number.parseFloat(prop('@Importe')(obj))
    let totalRetenido;
    let totalTransladado;

    if (Array.isArray(retenido)) {
      totalRetenido = retenido.reduce((acc, cur) => {
        return acc += Number.parseFloat(prop('@Importe')(cur))
      }, 0)

    } else {
      totalRetenido = Number.parseFloat(prop('@Importe')(retenido))
    }
    if (Array.isArray(translados)) {
      totalTransladado = translados.reduce((acc, cur) => {
        return acc += Number.parseFloat(prop('@Importe')(cur))
      }, 0)
      totalTransladado = Math.round(totalTransladado * 100) / 100
    } else {
      totalTransladado = Math.round(Number.parseFloat(prop('@Importe')(translados)) * 100) / 100
    }
    return Number.parseInt(((subtotal + totalTransladado) - totalRetenido) * 100, 10) / 100
  },
  totalCalculado: (obj) => {
    const translados = path(['cfdi:Impuestos', 'cfdi:Traslados', 'cfdi:Traslado'])(obj)
    const subtotal = Number.parseFloat(prop('@Importe')(obj))
    let totalTransladado;

    if (Array.isArray(translados)) {
      totalTransladado = translados.reduce((acc, cur) => {
        return acc += Number.parseFloat(prop('@Importe')(cur))
      }, 0)
    } else {
      totalTransladado = Number.parseFloat(prop('@Importe')(translados))
    }
    return Math.round((subtotal + totalTransladado) * 100) / 100
  },
  ivaCalculado: (obj) => {
    let translados = path(['cfdi:Impuestos', 'cfdi:Traslados', 'cfdi:Traslado'])(obj)
    let iva
    if (Array.isArray(translados)) {
      iva = pipe(find(propEq('@Impuesto', '002')))(translados)
    } else {
      iva = ifElse(propEq('@Impuesto', '002'), () => translados, () => undefined)(translados)
    }
    return iva ? Number.parseFloat(prop('@Importe')(iva)) : 0
  },
  iepsCalculado: (obj) => {
    let translados = path(['cfdi:Impuestos', 'cfdi:Traslados', 'cfdi:Traslado'])(obj)
    let impuesto
    const IEPS = '003'
    if (Array.isArray(translados)) {
      impuesto = pipe(find(propEq('@Impuesto', IEPS)))(translados)
    } else {
      impuesto = ifElse(propEq('@Impuesto', IEPS), () => translados, () => undefined)(translados)
    }
    return impuesto ? Number.parseFloat(prop('@Importe')(impuesto)) : 0
  },
  subtotalCalculado: pipe(prop('@Importe'), Number.parseFloat),
  cantidad: pipe(prop('@Cantidad'), Number.parseInt),
  claveProdServ: prop('@ClaveProdServ'),
}

export const totals = {
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  IVA: {
    name: 'IVA',
    label: 'IVA',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ieps: {
    name: 'ieps',
    label: 'IEPS',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagado: {
    name: 'montoPagado',
    label: 'Monto Pagado',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagoTransito: {
    name: 'montoPagoTransito',
    label: 'Monto Pago Tránsito',
    value: 0,
    format: (value) => numeral(Math.round(+value * 100) / 100).format('$ 0,0.00'),
    align: 'right',
  },
  montoPagar: {
    name: 'montoPagar',
    label: 'Monto por Pagar',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  estatusFacturaProveedor: {
    name: 'estatusFactura',
    label: 'Estatus Factura Proveedor',
    valueProperty: 'id',
    valueLabel: 'estatus',
    disabled: true,
  },
  numeroFactura: {
    name: 'numeroFactura',
    label: 'Numero de factura',
  },
  UUID: {
    name: 'UUID',
    label: 'UUID',
    disabled: true,
  },
  total: {
    name: 'total',
    label: 'Total',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  ISRRetenido: {
    name: 'ISRRetenido',
    label: 'ISR Retenido',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  IVARetenido: {
    name: 'IVARetenido',
    label: 'IVA Retenido',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  netoDepositar: {
    name: 'netoDepositar',
    label: 'Neto a depositar',
    value: 0,
    format: (value) => numeral(value).format('$ 0,0.00', Math.floor),
    align: 'right',
  },
}

export const conceptData = {
  idColaborador: {
    name: 'idColaborador',
    label: 'Colaborador',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'nombreConcatenado',
    trigger: 'changeCollaborator',
    placeholder: 'Buscar colaborador por nombre...',
  },
  colaborador: {
    name: 'colaborador',
    label: 'Colaborador',
    value: ''
  },
  idCuentaColaborador: {
    name: 'idCuentaColaborador',
    label: 'Clabe Colaborador',
    value: '',
    validation: 'required',
    valueProperty: 'id',
    valueLabel: 'clabe',
    trigger: 'changeCuentaCollaborator',
  },
  cuentaColaborador: {
    name: 'cuentaColaborador',
    label: 'Cuenta Colaborador',
    value: '',
  },
  netoPagar: {
    name: 'netoPagar',
    label: 'Neto a pagar',
    value: '',
    validation: 'required',
    pattern: 'number',
    trigger: 'updateCalculations',
  },
  subtotal: {
    name: 'subtotal',
    label: 'Subtotal',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  iva: {
    name: 'iva',
    label: 'IVA',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
  total: {
    name: 'total',
    label: 'Total',
    value: '',
    format: (value) => numeral(value).format('$ 0,0.00'),
    align: 'right',
  },
}
export const paymentSalaries =
  [
    {
      title: 'ID',
      datakey: 'id',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Estatus Orden',
      datakey: 'estatus',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Nombre o Razón Social',
      datakey: 'nombreRazonSocial',
      sortable: true,
      width: '40%',
    },
    {
      title: 'Total',
      datakey: 'Total',
      format: '$ 0,0.00',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '10%',
    }
  ];
export const procesingPaymentSalaries =
  [
    {
      title: 'Id Orden Pago',
      datakey: 'idOrdenPago',
      sortable: true,
      width: '8%',
    },
    {
      title: 'Nombre',
      datakey: 'nombre',
      sortable: true,
      width: '20%',
    },
    {
      title: 'RFC',
      datakey: 'rfc',
      sortable: true,
      width: '15%',
    },
    {
      title: 'CURP',
      datakey: 'curp',
      sortable: true,
      width: '15%',
    },
    {
      title: 'Clabe',
      datakey: 'clabe',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Neto a percibir',
      datakey: 'netoPercibir',
      format: '$ 0,0.00',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '5%',
    }
  ];
export const paidPaymentSalaries =
  [
    {
      title: 'Id Orden Pago',
      datakey: 'idOrdenPago',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Nombre',
      datakey: 'nombre',
      sortable: true,
      width: '20%',
    },
    {
      title: 'RFC',
      datakey: 'rfc',
      sortable: true,
      width: '15%',
    },
    {
      title: 'CURP',
      datakey: 'curp',
      sortable: true,
      width: '15%',
    },
    {
      title: 'Clabe',
      datakey: 'clabe',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Neto a percibir',
      datakey: 'netoPercibir',
      format: '$ 0,0.00',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '5%',
    },
  ];
export const rejectedPaymentSalaries =
  [
    {
      title: 'Id Orden Pago',
      datakey: 'idOrdenPago',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Nombre',
      datakey: 'nombre',
      sortable: true,
      width: '20%',
    },
    {
      title: 'RFC',
      datakey: 'rfc',
      sortable: true,
      width: '15%',
    },
    {
      title: 'CURP',
      datakey: 'curp',
      sortable: true,
      width: '15%',
    },
    {
      title: 'Clabe',
      datakey: 'clabe',
      sortable: true,
      width: '20%',
    },
    {
      title: 'Neto a percibir',
      datakey: 'netoPercibir',
      format: '$ 0,0.00',
      sortable: true,
      width: '10%',
    },
    {
      title: 'Acciones',
      custom: 'actions',
      width: '5%',
    },
  ];

export const installment = {
  divisaMoneda: {
    name: 'divisaMoneda',
    label: 'Moneda pago',
  },
  cargo: {
    label: 'Cargos',
    name: 'cargo',
    validation: 'required|greaterThan:0',
    pattern: 'number',
    value: 0,
    disabled: true,
  },
  fechaTransaccion: {
    label: 'Fecha de Transacción',
    name: 'fechaTransaccion',
    validation: `required`,
    value: undefined,
  },
  estatus: {
    label: 'Estatus',
    name: 'estatus',
  },
  idOrden: {
    label: 'Orden Pago',
    name: 'idOrden',
  },
  referencia: {
    label: 'Referencia Banco',
    name: 'referencia',
  },
  metodoPago: {
    label: 'Metódo de pago',
    name: 'metodoPago',
  },
  cuentaMxn: {
    label: 'Cuenta MXN',
    name: 'cuentaMxn',
  },
  claveRastreo: {
    label: 'Clave de rastreo',
    name: 'claveRastreo',
  },
  typePaymentProvider: {
    label: 'Tipo de Pago',
    name: 'typePaymentProvider',
  }
}

export const installmentsCol = [
  {
    title: 'Id',
    datakey: 'id',
  },
  {
    title: 'Fecha de transacción',
    datakey: 'fechaTransaccion',
    // format: 'dd/MM/YY',
  },
  {
    title: 'Estatus',
    datakey: 'estatusTexto',
  },
  {
    title: 'Cargo',
    datakey: 'cargo',
    format: '$ 0,0.00',
  },
  {
    title: 'Clave de Rastreo',
    datakey: 'claveRastreo',
  },
  {
    title: 'Referencia del banco',
    datakey: 'referenciaBanco'
  },
  {
    title: 'Acciones',
    custom: 'acciones',
  }
]